// Company standard: all user-facing timestamps are displayed in Eastern Time,
// regardless of where the viewer's browser is located. This keeps what a
// reporter sees in the portal consistent with the generated PDF worksheet and
// with what admins see in the admin portal.
//
// Use these helpers for *instants* (ISO timestamps such as submittedAt or
// createdAt). Do NOT use them for calendar dates like jobDate/dueDate, which are
// date-only strings anchored with "T12:00:00" and carry no time-of-day meaning.
export const COMPANY_TIMEZONE = 'America/New_York';

const LOCALE = 'en-US';

function toDate(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  const date = typeof value === 'string' ? new Date(value) : value;
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * Format an instant as an Eastern Time date and time, labelled with the zone
 * (e.g. "9/22/2026, 3:00:00 PM EDT"). DST is handled automatically.
 */
export function formatDateTime(
  value: string | Date | null | undefined,
  options: Intl.DateTimeFormatOptions = {}
): string {
  const date = toDate(value);
  if (!date) return '';
  return date.toLocaleString(LOCALE, {
    timeZone: COMPANY_TIMEZONE,
    timeZoneName: 'short',
    ...options,
  });
}

/**
 * Format an instant as an Eastern Time calendar date (e.g. "9/22/2026"), so the
 * day doesn't roll forward for timestamps recorded late in the evening ET.
 */
export function formatDate(
  value: string | Date | null | undefined,
  options: Intl.DateTimeFormatOptions = {}
): string {
  const date = toDate(value);
  if (!date) return '';
  return date.toLocaleDateString(LOCALE, {
    timeZone: COMPANY_TIMEZONE,
    ...options,
  });
}
